import { t } from "../../../services/utils";
import React from "react";
import ProfileImageView from "../../../components/ProfileImageView";
import storyTypes from "../../../constants/storyTypes";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import {
  primaryColor,
  primaryDark,
  primaryDark60,
} from "../../../constants/colors";
import { displayDateFromISO } from "../../../services/date-utils";
import { storyListViewTypes } from "../StoryListView";
import IconMoon from "../../../components/IconMoon";
import { Trans } from "react-i18next";
class TitleView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
    };
  }
  handleClick = (event) => {
    event.stopPropagation();
    this.setState({
      anchorEl: event.currentTarget,
    });
  };
  handleClose = (event) => {
    const value = Number(event.currentTarget.value);
    event.stopPropagation();
    this.setState({
      anchorEl: null,
    });
    if (value === 1) {
      if (this.props.isPublic) {
        this.props.handler.makeStoryPrivate(this.props.storyId);
      } else {
        this.props.handler.makeStoryPublic(this.props.storyId);
      }
    } else if (value === 2) {
      this.props.handler.archiveStory(this.props.storyId);
    } else if (value === 3) {
      if (this.props.pinned) {
        this.props.handler.unpinStory(this.props.storyId);
      } else {
        this.props.handler.pinStory(this.props.storyId);
      }
    }
  };
  goToUserDiary = () => {
    const { clientId, handler } = this.props;
    handler.loadUserDiary(clientId);
  };
  renderName = () => {
    if (this.props.viewType === storyListViewTypes.FOR_NEWS) {
      if (this.props.primaryTrainer) {
        return (
          <span
            onClick={this.goToUserDiary}
            style={{
              ...styles.firstName,
              ...{
                cursor: "pointer",
              },
            }}
          >
            {this.props.firstName}
          </span>
        );
      }
    }
    return <span style={styles.firstName}>{this.props.firstName}</span>;
  };

  renderName2 = () => {
    if (this.props.viewType === storyListViewTypes.FOR_NEWS) {
      if (this.props.primaryTrainer) {
        return (
          <span
            onClick={this.goToUserDiary}
            style={{
              ...styles.firstName,
              ...{
                cursor: "pointer",
              },
            }}
          >
            {/* {this.props.firstName} */}
          </span>
        );
      }
    }
    return <span style={styles.firstName}></span>;
  };

  render = () => {
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);
    let title;
    const { goal } = this.props;
    switch (this.props.storyType) {
      case storyTypes.WORKOUT_LOG: {
        title = (
          <div style={styles.title}>
            {/* {this.renderName()} */}
            <Trans
              i18nKey="userLoggedAWorkout"
              values={{ name: this.props.firstName }}
              defaults="<t1>{{name}}</t1> logged a <t2>workout</t2>"
              components={{
                t1: this.renderName2(),
                t2: <span style={styles.action}></span>,
              }}
            />

            {/* {t("loggedA")}{" "}
            <span style={styles.action}>{t("workout")}</span> */}
          </div>
        );
        break;
      }
      case storyTypes.ASSESSMENT: {
        title = (
          <div style={styles.title}>
            {/* {this.renderName()}  */}

            <Trans
              i18nKey="userAddedAnAssessment"
              values={{ name: this.props.firstName }}
              defaults="<t1>{{name}}</t1> added an <t2>assessment</t2>"
              components={{
                t1: this.renderName2(),
                t2: <span style={styles.action}></span>,
              }}
            />

            {/* {t("addedAn")}{" "}
            <span style={styles.action}>{t("assessment")}</span> */}
          </div>
        );
        break;
      }
      case storyTypes.LINK: {
        title = (
          <div style={styles.title}>
            {/* {this.renderName()}  */}
            <Trans
              i18nKey="userSharedAPage"
              values={{ name: this.props.firstName }}
              defaults="<t1>{{name}}</t1> shared a <t2>page</t2>"
              components={{
                t1: this.renderName2(),
                t2: <span style={styles.action}></span>,
              }}
            />

            {/* {t("sharedA")}{" "}
            <span style={styles.action}>{t("page")}</span> */}
          </div>
        );
        break;
      }
      case storyTypes.MEAL_LOG: {
        title = (
          <div style={styles.title}>
            {/* {this.renderName()}  */}
            <Trans
              i18nKey="userLoggedAMeal"
              values={{ name: this.props.firstName }}
              defaults="<t1>{{name}}</t1> logged a <t2>meal</t2>"
              components={{
                t1: this.renderName2(),
                t2: <span style={styles.action}></span>,
              }}
            />

            {/* {t("loggedA")}{" "}
            <span style={styles.action}>{t("meal")}</span> */}
          </div>
        );
        break;
      }
      case storyTypes.PROGRESS_PHOTO: {
        title = (
          <div style={styles.title}>
            {/* {this.renderName()} */}
            <Trans
              i18nKey="userAddedAProgressPhoto"
              values={{ name: this.props.firstName }}
              defaults="<t1>{{name}}</t1> added a <t2>progress photo</t2>"
              components={{
                t1: this.renderName2(),
                t2: <span style={styles.action}></span>,
              }}
            />

            {/* {t("addedA")}{" "}
            <span style={styles.action}>{t("progressPhoto")}</span> */}
          </div>
        );
        break;
      }
      case storyTypes.POST: {
        title = (
          <div style={styles.title}>
            {/* {this.renderName()} */}
            <Trans
              i18nKey="userAddedAPost"
              values={{ name: this.props.firstName }}
              defaults="<t1>{{name}}</t1> added a <t2>post</t2>"
              components={{
                t1: this.renderName2(),
                t2: <span style={styles.action}></span>,
              }}
            />

            {/* {t("addedA")}{" "}
            <span style={styles.action}>{t("post")}</span> */}
          </div>
        );
        break;
      }
      case storyTypes.CHECKIN: {
        title = (
          <div style={styles.title}>
            {/* {this.renderName()}  */}
            <Trans
              i18nKey="userDidACheckin"
              values={{ name: this.props.firstName }}
              defaults="<t1>{{name}}</t1> did a <t2>check-in</t2>"
              components={{
                t1: this.renderName2(),
                t2: <span style={styles.action}></span>,
              }}
            />

            {/* {t("didA")}{" "}
            <span style={styles.action}>{t("checkin")}</span> */}
          </div>
        );
        break;
      }
    }
    let status = "";
    if (!this.props.isPublic) {
      status = <span data-testid="story-lock-icon"><IconMoon icon="lock" color={primaryDark60} /></span>;
    }
    return (
      <div
        style={{
          ...styles.container,
          ...(this.props.pinned && {
            borderTop: "2px solid #ff9f00",
          }),
        }}
      >
        <ProfileImageView
          photoId={this.props.photoId}
          style={styles.profilePic}
          circular={true}
          placeholderSize={36}
        />
        <div style={styles.main}>
          {title}
          <div style={styles.date}>{displayDateFromISO(this.props.date)}</div>
        </div>

        <div style={styles.rightIcons}>
          {status}
          {this.props.pinned && (
            <i
              className="fa fa-thumb-tack"
              aria-hidden="true"
              style={styles.checkinIcon}
              data-testid="story-pin-icon"
            />
          )}
          <div>
            <IconButton
              aria-label="More"
              aria-owns={open ? "long-menu" : undefined}
              aria-haspopup="true"
              onClick={this.handleClick}
              data-testid="story-menu-button"
              style={{
                // padding: "0px",
                // borderRadius: "unset",
                marginLeft: 10,
                marginTop: 0,
              }}
            >
              <IconMoon icon="moreH" color={primaryDark60} />
            </IconButton>
            <Menu
              id="long-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={this.handleClose}
              PaperProps={{
                style: {
                  maxHeight: 48 * 4.5,
                  minWidth: 100,
                },
              }}
              anchorOrigin={{
                horizontal: "right",
                vertical: "top",
              }}
              transformOrigin={{
                horizontal: "right",
                vertical: "top",
              }}
            >
              <MenuItem
                style={{
                  paddingTop: 11,
                  paddingBottom: 11,
                }}
                value="1"
                data-testid="story-menu-privacy"
                onClick={this.handleClose}
              >
                {this.props.isPublic
                  ? t("makeThisPostPrivate")
                  : t("makeThisPostPublic")}
              </MenuItem>
              {this.props.isPublic && (
                <MenuItem
                  style={{
                    paddingTop: 11,
                    paddingBottom: 11,
                  }}
                  value="3"
                  data-testid="story-menu-pin"
                  onClick={this.handleClose}
                >
                  {this.props.pinned ? t("unpinThisPost") : t("pinThisPost")}
                </MenuItem>
              )}
              <MenuItem
                style={{
                  paddingTop: 11,
                  paddingBottom: 11,
                }}
                key={"delete"}
                value="2"
                data-testid="story-menu-delete"
                onClick={this.handleClose}
              >
                {t("delete")}
              </MenuItem>
            </Menu>
          </div>
        </div>
      </div>
    );
  };
  onMenuActionChoosen = (e, item) => {
    if (item === "1") {
      if (this.props.isPublic) {
        this.props.handler.makeStoryPrivate(this.props.storyId);
      } else {
        this.props.handler.makeStoryPublic(this.props.storyId);
      }
    } else if (item === "2") {
      this.props.handler.archiveStory(this.props.storyId);
    }
  };
  static getHeight(props) {
    return 97;
  }
}
const styles = {
  container: {
    display: "flex",
    flexDirection: "row",
    flex: "1 1 auto",
    backgroundColor: "white",
    marginTop: 20,
    padding: "16px 20px",
    border: "1px solid #EAE9EF",
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
  },
  profilePic: {
    width: 48,
    height: 48,
    backgroundColor: "transparent",
    marginRight: 5,
    // margin: 10
    // marginLeft: 35
  },

  title: {
    color: primaryDark,
    fontWeight: "400",
    fontSize: 16,
  },
  firstName: {
    color: primaryDark,
    fontWeight: "500",
  },
  action: {
    color: primaryDark,
    fontWeight: "500",
  },
  main: {
    display: "flex",
    flexDirection: "column",
    flex: "1 1 auto",
    justifyContent: "center",
    marginLeft: 16,
  },
  date: {
    fontSize: 14,
    color: primaryDark60,
    lineHeight: "16px",
    marginTop: 4,
  },
  status: {
    height: 24,
    width: 24,
  },
  rightIcons: {
    display: "flex",
    alignItems: "center",
    marginTop: -20,
  },
  checkinIcon: {
    color: "#FFB300",
    marginLeft: 10,
    transform: "rotate(45deg)",
  },
};
export default TitleView;
